<div class="exame-prescricao">
    <div class="item">
        <div class="info">
            <div class="logo logo-info">
                <i class="hgi hgi-stroke hgi-google-doc"></i>
            </div>
            <div class="nome">
                {{ anexo.arquivo.nome }}
            </div>
        </div>
        <div class="options">
            <button type="button" class="btn btn-outline-secondary" (click)="download()">
                <i class="hgi hgi-stroke hgi-download-04"></i>
            </button>
        </div>
    </div>
    <div class="logs">
        <ng-container>
            <p class="log">
                <i class="hgi hgi-stroke hgi-clock-01"></i>
                Anexo enviado em {{ anexo.creationTime | date: 'dd/MM/yyyy HH:mm' }}.
            </p>
        </ng-container>

    </div>
</div>